module.exports = __webpack_public_path__ + "static/media/josiah.cd6d0a5c.jpg";